export interface SearchQueryOutputApiModel {
    search_text: string;
    tags: number[];
    peoples: number[];
    campaigns: number[];
    is_my_story: boolean;
}